import { createSelector } from "reselect";

import { getSites, getSiteById } from "services/redux/selectors/sites";

export const getSitesOnTest = (state) => state.sitesOnTest.data.onTest;

export const getSitesOnTestSortField = (state) => state.sitesOnTest.sortField;
export const getSitesOnTestSortDirection = (state) => state.sitesOnTest.sortDirection;
export const getSitesOnTestFilters = (state) => state.sitesOnTest.filters;
export const getSitesOnTestPageSize = (state) => state.sitesOnTest.pageSize;
export const getSitesOnTestRequestPageNumber = (state) => state.sitesOnTest.requestPageNumber;

export const getSitesOnTestSites = createSelector(
  [getSitesOnTest, getSites],
  (sitesOnTest, sites) => {
    // Build site data into each sitesOnTest item
    let resultingSitesOnTest = sitesOnTest && sitesOnTest.map((sitesOnTestItem) => {
      // Find the site for this sitesOnTest item
      let sitesOnTestSite = getSiteById(sites, sitesOnTestItem.enterprise_site_id);

      return {
        ...sitesOnTestItem,
        site: { ...sitesOnTestSite },
      };
    });

    return resultingSitesOnTest || [];
  }
);